'use strict';

var chunkE35YN47O_js = require('../chunk-E35YN47O.js');
var chunkHUKGHOBJ_js = require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var o = require('react');
var n = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var o__default = /*#__PURE__*/_interopDefault(o);
var n__default = /*#__PURE__*/_interopDefault(n);

var _=n__default.default.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${({$gap:t})=>t};
`,$=n__default.default.span`
  color: ${({$color:t})=>t};
  font-size: ${({$size:t})=>t};
  font-weight: ${({$fontWeight:t})=>t};
  line-height: ${({$lineHeight:t})=>t};
  text-align: left;
`,f=n__default.default.a`
  color: ${({$color:t})=>t};
  font-size: ${({$size:t})=>t};
  &:hover, &:focus {
    color: var(--grey-500);
  }
  text-decoration: none;
`,m=({list:t,attachSchema:a=!0,baseUrl:i})=>{let{tokens:e}=chunkHUKGHOBJ_js.b();return !!(t||[]).length&&o__default.default.createElement(_,{$gap:e.spacing_8},t.map((r,s)=>o__default.default.createElement(o__default.default.Fragment,null,o__default.default.createElement($,{key:`breadcrumb-${s}`,$color:e.text_brand_text_accent,$size:e.font_size_xs,$fontWeight:e.font_weight_regular,$lineHeight:e.font_line_height_lg},r.url?o__default.default.createElement(f,{href:`${i}${r.url}`,$color:e.text_default_text_secondary,$size:e.font_size_xs},r.name):r.name),s<t.length-1&&o__default.default.createElement($,{$color:e.text_default_text_secondary,$size:e.font_size_xs,$fontWeight:e.font_weight_regular,$lineHeight:e.font_line_height_lg},"/"))),a&&o__default.default.createElement(chunkE35YN47O_js.a,{list:t,baseUrl:i}))};

exports.Breadcrumbs = m;
